// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3Dseq","head":"Table_head__MXy6B","col":"Table_col__2VGKe"};